export const prepareInitialData = (data = []) => {
  const updatedData = [];
  if (data.length) {
    for (let i = 0; i < data.length; i++) {
      const pog = data[i];
      updatedData.push({
        ...pog,
        selection: false,
      });
    }
    return updatedData;
  }
  return data;
};

export const prepareSettingsSaveData = (
  storeId,
  userId,
  filters,
  formData,
  selectedDepts
) => {
  let updatedData = {};
  updatedData = {
    StoreId: storeId,
    Category: filters?.category || null,
    PogNumber: filters?.planogramValue?.split("-")[1] || null,
    DiscMultiplier: formData.discountMultiplier || null,
    QtyMultiplier: formData.qtyMultiplier || null,
    CoreDiscount: formData.coreDiscount || null,
    NonCoreDiscount: formData.nonCoreDiscount || null,
    DatingDays: formData.datingDays || null,
    UserID: userId,
    DeptLetterList: selectedDepts,
  };
  return updatedData;
};

export const prepareCreatePOData = (
  storeId,
  userId,
  filters,
  formData,
  selectedDepts
) => {
  let updatedData = {};
  updatedData = {
    StoreId: storeId,
    Category: filters?.category || null,
    PogNumber: filters?.planogramValue?.split("-")[1] || null,
    PONumber: formData?.customPONumber,
    CreatePOBy:
      formData?.generatePOBy === "Department" ? "DEPT" : formData?.generatePOBy,
    UserID: userId,
    DeptLetterList: selectedDepts,
  };
  return updatedData;
};

export const prepareSaveDatesData = (
  storeId,
  userId,
  filters,
  releaseDate,
  selectedDepts
) => {
  let updatedData = {};
  updatedData = {
    StoreId: storeId,
    Category: filters?.category || null,
    PogNumber: filters?.planogramValue?.split("-")[1] || null,
    ReleaseDate: releaseDate,
    UserID: userId,
    DeptLetterList: selectedDepts,
  };
  return updatedData;
};

export const prepareDeleteDatesData = (
  storeId,
  userId,
  filters,
  selectedDepts
) => {
  let updatedData = {};
  updatedData = {
    StoreId: storeId,
    Category: filters?.category || null,
    PogNumber: filters?.planogramValue?.split("-")[1] || null,
    UserID: userId,
    DeptLetterList: selectedDepts,
  };
  return updatedData;
};

export const postSaveRestSelections = (deptList = []) => {
  const updatedDeptList = deptList?.map((dept) => ({
    ...dept,
    selection: false,
  }));
  return updatedDeptList;
};
